import React from "react";
import { Textarea as MantineTextarea, TextareaProps, useMantineTheme } from "@mantine/core";

interface CustomTextareaProps extends Omit<TextareaProps, "styles"> {}

/**
 * Textarea - Themed textarea component
 * Usage: <Textarea label="Message" placeholder="Enter your message" />
 */
export const Textarea: React.FC<CustomTextareaProps> = ({ ...props }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <MantineTextarea
      {...props}
      styles={{
        label: {
          color: other.textPrimary,
          marginBottom: "0.5rem",
          fontWeight: 500,
        },
        input: {
          backgroundColor: "rgba(26, 20, 16, 0.85)",
          border: "1px solid rgba(245, 238, 224, 0.15)",
          color: other.textPrimary,
          "&:focus": {
            borderColor: other.focusRingColor,
            boxShadow: other.focusRing,
          },
          "&::placeholder": {
            color: other.placeholderText,
          },
        },
        error: {
          color: other.errorText,
        },
      }}
    />
  );
};

export default Textarea;
